<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">Manage Scan Directories</div>
    </div>
    <div class="col-md-12 well-content">
        <table class="one-column-emphasis">
            <thead>
                <tr>
                    <th>Directory</th>
                    <th>Document Type</th>
                    <th>Setup Type</th>
                    <th>
                        <button
                            type="button"
                            [routerLink]="['/configure/scandirectorycreate']"
                            class="btn btn-default"
                            aria-disabled="false"
                            (click)="openCreateModal()">
                            Create
                        </button>
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (item of list; track item) {
                    <tr>
                        <td>{{ item.ScanDirectoryPath }}</td>
                        <td>
                            {{
                                item.ScanSetupType !== 5
                                    ? item.DocumentTypeName
                                    : aiEnabled
                                      ? "Automatically detected by AI OCR"
                                      : "(disabled)"
                            }}
                        </td>
                        <td>
                            @switch (item.ScanSetupType) {
                                @case (0) {
                                    All Pages One Document
                                }
                                @case (1) {
                                    Each Page One Document
                                }
                                @case (2) {
                                    Barcode Separated
                                }
                                @case (3) {
                                    Nothing
                                }
                                @case (4) {
                                    Zonal OCR
                                }
                                @case (5) {
                                    AI OCR{{ !aiEnabled ? " (disabled)" : "" }}
                                }
                            }
                        </td>
                        <td>
                            <div class="tableRollover">
                                <button
                                    [routerLink]="['/configure/scandirectoryedit']"
                                    [queryParams]="{id: item.ScanDirectoryID}"
                                    class="btn btn-default">
                                    Modify
                                </button>
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
